import { useScreenDetector } from "@/hooks/useScreenDetector";
import { SearchByPlateNumber } from "@/widgets/SearchByPlateNumber/SearchByPlateNumber";
import { SearchByVin } from "@/widgets/SearchByVin/SearchByVin";
import { SearchCar } from "@/widgets/SearchCar/SearchCar";
import { Tab } from "@/ui/DataDisplay/Tabs/types/tab.interface";
import { Tabs } from "@/ui/DataDisplay/Tabs/Tabs";
import { products } from "@/mock/products";
import { Products } from "@/widgets/Products/Products";
import { Advertisment } from "@/widgets/Adveristment/Advertisment";
import { Reviews } from "@/widgets/Reviews/Reviews";
import styles from './index.module.css';

/**
 * Главная страница
 * @returns {JSX.Element}
 */
export const IndexPage = () => {
    const { isDesktop, isMobile } = useScreenDetector();

    const tabs = [
        { label: 'Поиск по госномеру', content: <SearchByPlateNumber /> },
        { label: 'Поиск по VIN или номеру кузова', content: <SearchByVin /> },
        { label: 'Подбор по марке/модели авто', content: <SearchCar /> },
    ] as Tab[];

    return (
        <>
            {isDesktop && (<>
                <Tabs tabs={tabs} />
                <Products products={products} />
                <Advertisment />
                <Reviews />
            </>)}

            {isMobile && (<>
                <section className={styles.searchModule}>
                    <SearchByPlateNumber />
                    <SearchByVin />
                    <SearchCar />
                </section>
                <Products products={products} />
                <Advertisment />
                <Reviews />
            </>)}
        </>
    );
};